import alertBox from '@/components/generics/alert-box/alert-box.vue';

export default {
  components: {
    alertBox,
  },
  data() {
    return {
      promoCodeDetail: {},
      instantCreditDetail: {},
    };
  },
  computed: {
    showInstantCreditNotification() {
      return this.instantCreditDetail && typeof this.instantCreditDetail.success !== 'undefined';
    },
    instantCreditBoxLevel() {
      return this.instantCreditDetail.success ? 'success' : 'warning';
    },
    instantCreditBoxMessage() {
      return this.instantCreditDetail.success
        ? this.instantCreditDetail.friendlyDescription
        : this.instantCreditDetail.errorMessage;
    },
    showPromoNotification() {
      return this.promoCodeDetail && this.promoCodeDetail.showPromoCodeBox;
    },
    showPromoCode() {
      return this.promoCodeDetail && this.promoCodeDetail.promoCodeText;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/promoCode.js